import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

// RxJS
import { Observable } from 'rxjs';

// Services
import { AuthService } from '../services/auth.service';
import { PortalService } from 'src/app/portal/services/portal.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private portalService: PortalService,
    private router: Router,
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isLoggedIn()) return true;

    // Intentamos obtener el slug actual
    const entidad = this.portalService.getCurrentEntityValue();
    const slug = entidad?.slug || this.extractSlugFromUrl(state.url);

    const loginPath = slug ? `/${slug}/login` : '/';

    this.router.navigate([loginPath], {
      queryParams: { returnURL: state.url },
    });

    return false;
  }

  private extractSlugFromUrl(url: string): string | null {
    return this.portalService.getCurrentEntityValue()?.slug || null;
  }
}
